(function ($, Drupal, once) {
  Drupal.behaviors.filterValueTracking = {
    attach: function (context) {
      var fieldMap = {
        'Behandlungszone': 'select[name="field_booking_availability_target_id[]"]',
        'Behandlungsart': 'select[name="field_treatments_target_id_1[]"]'
      };

      // Track Select2 filters.
      $.each(fieldMap, function (filterName, selector) {
        $(once('filter-value-tracking', selector, context)).each(function () {
          var $select = $(this);

          // Store the initially selected values.
          var previousValues = ($select.val() || []).map(String);

          $select.on('change.filterValueTracking', function () {
            var currentValues = $select.val() || [];

            if (!Array.isArray(currentValues)) {
              currentValues = [currentValues];
            }

            currentValues = currentValues
            .filter(function (value) {
              return value !== '' && value !== 'All';
            })
            .map(String);

            var addedValues = currentValues.filter(function (value) {
              return !previousValues.includes(value);
            });

            var removedValues = previousValues.filter(function (value) {
              return !currentValues.includes(value);
            });

            window.dataLayer = window.dataLayer || [];

            function pushFilterEvent(eventName, value) {
              var $option = $select.find('option').filter(function () {
                return String(this.value) === value;
              }).first();

              window.dataLayer.push({
                event: eventName,
                filter_name: filterName,
                filter_id: value,
                filter_value: $option.text().trim(),
                page: '/beratung/spezialisten-finden'
              });
            }

            addedValues.forEach(function (value) {
              pushFilterEvent('filter_value_added', value);
            });

            removedValues.forEach(function (value) {
              pushFilterEvent('filter_value_removed', value);
            });

            previousValues = currentValues.slice();
          });
        });
      });

      // Track Google Reviews rating checkboxes.
      $(once(
          'google-rating-value-tracking',
          'input[name^="field_google_rating_value["]',
          context
      )).on('change.filterValueTracking', function () {
        var $checkbox = $(this);
        var rating = String($checkbox.val());

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          filter_name: 'Google-Bewertung',
          event: $checkbox.is(':checked')
              ? 'filter_value_added'
              : 'filter_value_removed',
          filter_id: rating,
          filter_value: rating,
          page: '/beratung/spezialisten-finden'
        });
      });
    }
  };
})(jQuery, Drupal, once);
